var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIrandom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0617 3.68803C16.4906 2.11209 14.4535 1.08434 12.2523 0.757096C10.0512 0.429855 7.80324 0.820547 5.84161 1.87126C3.87997 2.92198 2.30909 4.57679 1.36181 6.59041C0.414536 8.60404 0.141278 10.8693 0.582546 13.0504C1.02381 15.2315 2.15612 17.2124 3.81163 18.6995C5.46713 20.1865 7.55772 21.1006 9.77352 21.3062C11.9893 21.5117 14.2124 20.9979 16.1132 19.8408C18.014 18.6836 19.4914 16.9449 20.3264 14.8821H17.4535C16.6536 16.2949 15.431 17.4215 13.9576 18.1033C12.4842 18.7852 10.8342 18.988 9.23948 18.6834C7.64481 18.3787 6.18575 17.5819 5.06748 16.4049C3.94921 15.2279 3.22799 13.7301 3.00525 12.1219C2.78252 10.5137 3.06946 8.87621 3.82574 7.4396C4.58202 6.003 5.76958 4.83958 7.22142 4.11297C8.67326 3.38637 10.3163 3.13312 11.9196 3.38884C13.5228 3.64457 15.0056 4.3964 16.1593 5.53861L12.0441 9.70567H21.1029V0.64685L18.0617 3.68803Z",
    fill: "#BCBCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrandom);
export default __webpack_public_path__ + "static/media/irandom.0dfe6120c482fb85defddb9399e34fd6.svg";
export { ForwardRef as ReactComponent };